import React from "react";
import Logo from "./UI/Logo";

const footerLogos = [
  {
    url: `${process.env.REACT_APP_UI_URL}/images/icons/waterboard-logo-wht.svg`,
    altText: "Water Boards Logo",
    styles: "w-[100px]",
  },
  {
    url: `${process.env.REACT_APP_UI_URL}/images/icons/geosyntec-logo-wht.svg`,
    altText: "Geosyntec Logo",
    styles: "w-[100px]",
  },
  {
    url: `${process.env.REACT_APP_UI_URL}/images/icons/ESB-logo-wht.svg`,
    altText: "Babcock Logo",
    styles: "w-[100px]",
  },
];

const Footer = () => {
  return (
    <div className="main-container bg-primary text-white">
      <div className="content-container py-[5px] px-[10px] sm:px-[50px] md:px-[200px] flex-col">
        <div className="pt-4 w-full flex flex-col lg:flex-row justify-between gap-16 mb-10">
          <div className="flex flex-col md:flex-row gap-12">
            <div>
              <a href="https://www.owp.csus.edu/" target="_blank" rel="noreferrer">
                <img
                  src="/owp-logo-stacked-WHT-2color.svg"
                  alt="Water Programs Logo"
                  className="w-[150px] -mt-3"
                />
              </a>
            </div>
            <div className="text-xs">
              <p>Office of Water Programs</p>
              <p>3020 State University Drive</p>
              <p>Modoc Hall Suite 1001</p>
              <p>Sacramento, CA 95819</p>
              <br />
              <div className="text-secondary hover:text-accent">
                <h2>
                  <a href="tel:9162784483">916.278.4483</a>
                </h2>
              </div>
              <div className="text-secondary hover:text-accent">
                <h2>
                  <a href="mailto:pfas@owp.csus.edu">pfas@owp.csus.edu</a>
                </h2>
              </div>
              <br />
            </div>
          </div>
          <div className="block space-y-4 text-xs w-fit">
            <a href="https://www.waterboards.ca.gov/" target="_blank" rel="noreferrer">
              <div className="flex flex-row flex-wrap w-fit gap-4">
                {footerLogos.map((obj) => {
                  return <Logo {...obj} key={obj?.altText} />;
                })}
              </div>
            </a>
          </div>
        </div>
        <p className="text-[10px] mb-2">
          Funding for this project has been provided in full or in part through
          an agreement with the State Water Resources Control Board. The
          contents of this document do not necessarily reflect the views and
          policies of the foregoing, nor does mention of trade names or
          commercial products constitute endorsement or recommendation for use.
        </p>
        <hr className="w-full p-0 m-0" />
        <p className="mt-2 mb-6 text-[10px]">
          Copyright © {new Date().getFullYear()} Office of Water Programs. All
          Rights Reserved.
        </p>
      </div>
    </div>
  );
};

export default Footer;
